import React, {PureComponent} from 'react';
import { Callout, Intent } from '@blueprintjs/core';
import StripeReplacementModal from '../../modals/StripeReplacementModal';

class OrderSummary extends PureComponent {
    state = {
        hoveredItem: '',
        width: '',
        discountedAmount: this.props.discountedAmount ? this.props.discountedAmount : '',
        upcomingSwitchPlans: '',
        stripeReplacementModal: false
    };

    async componentDidMount() {

        await this.setState({width: this.container.offsetWidth,});
    }

    async componentDidUpdate() {
        if (this.props.discountedAmount && (this.state.discountedAmount !== this.props.discountedAmount)) {
            // console.log('order summary componentDidUpdate')
            let discountedAmount = this.props.discountedAmount

            await this.setState({
                discountedAmount
            })
        }

    }

    convertDate = (unix_timestamp) => {
// Create a new JavaScript Date object based on the timestamp
// multiplied by 1000 so that the argument is in milliseconds, not seconds.

        let miliseconds = (unix_timestamp) * 1000;
        /* Date calculation above should be checked */
        let toLocal = new Date(miliseconds).toLocaleDateString("en-US");

        let objectDate = new Date(toLocal);
        let fullDate = objectDate.toString();

        let year = fullDate.substring(11, 15);
        let month = fullDate.substring(4, 7);
        let day = fullDate.substring(8, 10);

        // console.log('convertDate: ', day + '. ' + month + ' ' + year)

        return day + '. ' + month + ' ' + year

    }

    render() {
        let orderAmount = this.props.orderAmount;
        let totalAmount = this.props.totalAmount
        let creditsAmount = this.props.creditsAmount;
        let vat = this.props.vat;
        let exclVat = this.props.exclVat;
        let newBalance = this.props.newBalance;
        let upcomingSwitchPlans = this.props.upcomingSwitchPlans;

        let invoiceEstimate = upcomingSwitchPlans && upcomingSwitchPlans.invoiceEstimate ? upcomingSwitchPlans.invoiceEstimate : '';
        let lineItems = upcomingSwitchPlans && upcomingSwitchPlans.invoiceEstimate && upcomingSwitchPlans.invoiceEstimate.lineItems ?
            upcomingSwitchPlans.invoiceEstimate.lineItems : '';

        let nextInvoiceEstimate = upcomingSwitchPlans && upcomingSwitchPlans.nextInvoiceEstimate ? upcomingSwitchPlans.nextInvoiceEstimate : '';
        let nextLineItems = nextInvoiceEstimate && nextInvoiceEstimate.line_items ? nextInvoiceEstimate.line_items : '';

        let isTaxed = lineItems && lineItems.length ? lineItems[0].isTaxed :
            nextLineItems && nextLineItems.length ? nextLineItems[0].isTaxed : false;
        let taxAmount = invoiceEstimate && isTaxed ? invoiceEstimate.taxes.amount/100 :
            nextInvoiceEstimate && isTaxed ? nextInvoiceEstimate.taxes.amount/100 : '';

        /* creditsApplied are credits that were paied for previous plan and should be calculated in discountAmount */
        let creditsApplied = invoiceEstimate && invoiceEstimate.creditsApplied ? invoiceEstimate.creditsApplied :
            nextInvoiceEstimate && nextInvoiceEstimate.creditsApplied ? nextInvoiceEstimate.creditsApplied : 0;

        let discountAmount = invoiceEstimate && lineItems && lineItems.length && lineItems[0].discountAmount ? lineItems[0].discountAmount + creditsApplied :
            nextInvoiceEstimate && nextLineItems && nextLineItems.length && nextLineItems[0].discountAmount ? nextLineItems[0].discountAmount + creditsApplied : '';

        if(creditsApplied && !discountAmount){
            discountAmount = creditsApplied;
        }
        // console.log('creditsApplied: ', creditsApplied, discountAmount)
        // let date = 1643324400;
        // console.log('konvertovan datum: ', this.convertDate(date))
        let nextLineItemDate = nextLineItems && nextLineItems.length && nextLineItems[0].dateFrom ? this.convertDate(nextLineItems[0].dateFrom) : '';
        // console.log('next data: ', nextInvoiceEstimate, nextLineItems, nextLineItemDate)
        // let upcomingSwitchTotal = upcomingSwitchPlans && upcomingSwitchPlans.lines && upcomingSwitchPlans.lines.data && upcomingSwitchPlans.discount ? upcomingSwitchPlans.total / 100 : '';
        let upcomingSwitchTotal = upcomingSwitchPlans && upcomingSwitchPlans.lines && upcomingSwitchPlans.lines.data ? upcomingSwitchPlans.total / 100 : '';
        let previousCredit = this.props.previousCredit || 0;
        let futureCredit = (parseInt(previousCredit) + parseInt(creditsAmount ? parseInt(creditsAmount) : 0)).toFixed(2);
        let subtotalWithDiscount = upcomingSwitchPlans && upcomingSwitchPlans.discount && upcomingSwitchPlans.discount.coupon ?
            vat ? upcomingSwitchTotal - vat : upcomingSwitchTotal : '';
            // upcomingSwitchPlans.subtotal/100 - ((upcomingSwitchPlans.subtotal/100) * (upcomingSwitchPlans.discount.coupon.percent_off/100)) : '';
        // console.log('subtotalWithDiscount: ', subtotalWithDiscount)

        // let blackVat
        // if (this.props.discountedAmount) {
        //     console.log('entered vat')
        //     if (orderAmount === 3600) {
        //         blackVat = 2988 / 10
        //         console.log('black VAT 1: ', blackVat)
        //     } else if (orderAmount === 1188) {
        //         blackVat = 948 / 10
        //         console.log('black VAT 2: ', blackVat)
        //     }
        // }
        // let blackOrder
        //
        // if (orderAmount === 3600) {
        //     blackOrder = 2988 / 2
        //
        // } else if (orderAmount === 1188) {
        //     blackOrder = 948 / 2
        // }
        // console.log('orderAmount: ', orderAmount);
        // console.log('blackOrder: ', blackOrder)
        return (
            <div className='order-summary-wrapper' ref={el => (this.container = el)}>
                {/*{console.log('orderSummary props: ', this.props)}*/}
                <div className='order-summary-top-content'>
                    {/*<img className='black-friday-label' src="/img/discount/black-friday-label.png"*/}
                         {/*alt="black friday"/>*/}
                    <h2>Order Summary</h2>
                    {this.props.cartList && this.props.cartList.length ?
                        <div>
                            { this.props.cartList.find(item => item.type === 'yearly') ?
                                <div className='cart-container'>
                                    <div className='text-wrapper'>
                                        <span><strong>{ this.props.cartListTitle }</strong></span>
                                    </div>
                                    <div className='text-wrapper-small'>
                                        <span>Yearly Subscription</span>
                                    </div>
                                    { this.props.cartList.map(item => item.type === 'yearly' ?
                                        <div
                                            className='text-wrapper' style={ {
                                            alignItems: 'flex-start',
                                            // paddingRight: 30,
                                            position: 'relative',
                                            // width: this.state.width - 90
                                        } }
                                            onMouseEnter={ () => this.setState({ hoveredItem: item.phoneNumber }) }
                                            onMouseLeave={ () => this.setState({ hoveredItem: '' }) }
                                        >
                                            <span>{ item[ this.props.cartItemIdentifier ] } { item.countryCode ? '(' + item.countryCode + ')' : '' }</span>
                                            <span><strong>${ (parseInt(item[ this.props.cartCostIdentifier ]) * ((item.countryCode === 'US' || item.countryCode === 'CA') ? 24 : 12)).toFixed(2) }</strong></span>
                                            {
                                                this.props.disableItemRemoval ?
                                                    ''
                                                    :
                                                    <i
                                                        onClick={ () => this.props.removeItem(item) }
                                                        style={ {
                                                            position: 'absolute',
                                                            right: -15,
                                                            top: 3,
                                                            cursor: 'pointer',
                                                            opacity: this.state.hoveredItem === item.phoneNumber ? 1 : 0
                                                        } }
                                                        className="fas fa-times mobile-force-opacity"
                                                        onMouseEnter={ () => this.setState({ hoveredItem: item.phoneNumber }) }
                                                        onMouseLeave={ () => this.setState({ hoveredItem: '' }) }
                                                    ></i>
                                            }
                                        </div>
                                        :
                                        ''
                                    ) }
                                </div>
                                :
                                ''
                            }
                            { this.props.cartList.find(item => item.type === 'monthly') ?
                                <div className='cart-container'>
                                    <div className='text-wrapper'>
                                        <span><strong>{ this.props.cartListTitle }</strong></span>
                                    </div>
                                    <div className='text-wrapper-small'>
                                        <span>Monthly Subscription</span>
                                    </div>
                                    { this.props.cartList.map(item => item.type === 'monthly' ?
                                        <div
                                            className='text-wrapper' style={ {
                                            alignItems: 'flex-start',
                                            // paddingRight: 30,
                                            position: 'relative',
                                            // width: this.state.width - 90
                                        } }
                                            onMouseEnter={ () => this.setState({ hoveredItem: item.phoneNumber }) }
                                            onMouseLeave={ () => this.setState({ hoveredItem: '' }) }
                                        >
                                            <span>{ item[ this.props.cartItemIdentifier ] } { item.countryCode ? '(' + item.countryCode + ')' : '' }</span>
                                            <span><strong>${ item[ this.props.cartCostIdentifier ] }</strong></span>
                                            {
                                                this.props.disableItemRemoval ?
                                                    ''
                                                    :
                                                    <i
                                                        onClick={ () => this.props.removeItem(item) }
                                                        style={ {
                                                            position: 'absolute',
                                                            right: -15,
                                                            top: 3,
                                                            cursor: 'pointer',
                                                            opacity: this.state.hoveredItem === item.phoneNumber ? 1 : 0
                                                        } }
                                                        className="fas fa-times mobile-force-opacity"
                                                        onMouseEnter={ () => this.setState({ hoveredItem: item.phoneNumber }) }
                                                        onMouseLeave={ () => this.setState({ hoveredItem: '' }) }
                                                    ></i>
                                            }
                                        </div>
                                        :
                                        ''
                                    ) }
                                </div>
                                :
                                ''
                            }
                        </div>
                        :
                        invoiceEstimate || nextInvoiceEstimate ?
                            <div className='cart-container'>
                                {
                                    // upcomingSwitchPlans is used and generated on Apply Coupon, and passed to orderSummary
                                    // should be set in parent component as response.invoice_upcoming
                                    // so in Order Summary its values are properly calculated and displayed
                                }
                                <div
                                    className='text-wrapper' style={{
                                    alignItems: 'flex-start',
                                    // paddingRight: 30,
                                    position: 'relative',
                                    // width: this.state.width - 90
                                }}
                                >
                                    <div style={{
                                        width: '70%',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}>
                                        <span><strong>{lineItems ? lineItems[0].description : nextLineItems[0].description}</strong></span>
                                        <span>{}</span>
                                    </div>
                                    <span>${(lineItems ? lineItems[0].amount/100 : nextLineItems[0].amount/100).toFixed(2)}</span>
                                </div>

                                <div style={{height: 20}}/>
                                { discountAmount ?
                                    <div className='text-wrapper m-sm-b'>
                                        <span><strong>Discount</strong></span>
                                        <span>${(discountAmount/100).toFixed(2)}</span>
                                    </div>
                                    :
                                    ''
                                }
                                <div style={{height: 50}}/>
                                { /* Kod ispod iskomentarisan zbog toga sto vise ne dobijamo listu svih popusta kao kod stripe-a */}

                                {/*<div className='text-wrapper' style={{*/}
                                {/*    alignItems: 'flex-start',*/}
                                {/*    // paddingRight: 30,*/}
                                {/*    position: 'relative',*/}
                                {/*    // width: this.state.width - 90*/}
                                {/*}}>*/}
                                {/*    <div*/}
                                {/*        style={ {*/}
                                {/*            width: '70%',*/}
                                {/*            display: 'flex',*/}
                                {/*            flexDirection: 'column'*/}
                                {/*        } }>*/}
                                {/*        <span><strong>{ this.state.upcomingSwitchPlans && this.state.invoiceEstimate &&*/}
                                {/*        this.state.lineItems && this.state.lineItems.length &&*/}
                                {/*        this.state.lineItems[0].description ?*/}
                                {/*            this.state.lineItems[0].description : '' }</strong></span>*/}
                                {/*        <span>{ item.description }</span>*/}
                                {/*    </div>*/}
                                {/*    <span>${ amount }</span>*/}
                                {/*</div>*/}
                            </div>
                            :
                            ''
                    }
                    {/*{this.props.stripePlanId && (!upcomingSwitchPlans ||(!upcomingSwitchPlans.lines || !upcomingSwitchPlans.lines.data || !upcomingSwitchPlans.discount || !upcomingSwitchPlans.discount.coupon )) ?*/}
                    {/*{this.props.stripePlanId && (!upcomingSwitchPlans ||(!upcomingSwitchPlans.lines || !upcomingSwitchPlans.lines.data)) ?*/}
                    {/*    <div className='text-wrapper'>*/}
                    {/*        <span><strong>{this.props.stripePlanId.startsWith('essentials_monthly') ? 'Essentials Plan' : 'Premium Plan'}</strong></span>*/}
                    {/*        <span><strong>$ {orderAmount ? parseFloat(orderAmount).toFixed(2) : 0.00}</strong></span>*/}
                    {/*    </div>*/}
                    {/*    :*/}
                    {/*    ''*/}
                    {/*}*/}
                    {
                        this.props.viberSubscriptionSelected || this.props.showViberPlanName ?
                            <div className='text-wrapper'>
                                <span>{this.props.showViberPlanName || this.props.viberSubscriptionSelected} Viber plan</span>
                                <span>${orderAmount ? parseFloat(orderAmount).toFixed(2) : 0.00}</span>
                            </div>
                            :
                            ''
                    }

                    {/*{this.props.stripePlanId && (!upcomingSwitchPlans ||(!upcomingSwitchPlans.lines || !upcomingSwitchPlans.lines.data || !upcomingSwitchPlans.discount || !upcomingSwitchPlans.discount.coupon )) ?*/}
                    {/*{this.props.stripePlanId && (!upcomingSwitchPlans ||(!upcomingSwitchPlans.lines || !upcomingSwitchPlans.lines.data)) ?*/}
                    {/*    <div className='text-wrapper'>*/}
                    {/*        <span>{this.props.yearlySubscription ? 'Annual Subscription' : '1 month'}</span>*/}
                    {/*    </div>*/}
                    {/*    :*/}
                    {/*    ''*/}
                    {/*}*/}

                    {
                        nextLineItemDate && !invoiceEstimate ?
                            <div className='text-wrapper m-sm-b'>
                                <span><strong>Your subscription will be updated starting with the next billing cycle on {nextLineItemDate}</strong></span>
                            </div>
                            :
                            ''
                    }

                    <div style={{height: 140}}/>
                    {(this.props.cartListTitle !== 'Phone Numbers') || !this.props.cartList || !this.props.cartList.length ?
                        <React.Fragment>
                            <div className='text-wrapper m-m-b'>
                                <span>Excl. VAT:</span>
                                {/*<span>$ {upcomingSwitchTotal ? parseFloat(upcomingSwitchTotal).toFixed(2) : 0.00 }</span>*/}
                                <span>${ upcomingSwitchPlans && invoiceEstimate && invoiceEstimate.amountDue ?
                                    (invoiceEstimate.amountDue / 100).toFixed(2)
                                    :
                                    upcomingSwitchPlans && invoiceEstimate && (invoiceEstimate.amountDue === 0) ?
                                        invoiceEstimate.amountDue.toFixed(2)
                                        :
                                        upcomingSwitchPlans && nextInvoiceEstimate && nextInvoiceEstimate.amountDue ?
                                            (nextInvoiceEstimate.amountDue / 100).toFixed(2)
                                            :
                                            upcomingSwitchPlans && nextInvoiceEstimate && (nextInvoiceEstimate.amountDue === 0) ?
                                                nextInvoiceEstimate.amountDue.toFixed(2)
                                                :
                                                totalAmount ? parseFloat(totalAmount).toFixed(2) : '0.00'}</span>
                            </div>
                            {/*{console.log('tax data: ', isTaxed && taxAmount)}*/}
                            <div className='text-wrapper'>
                                <span>VAT:</span>
                                {/*<span>{vat && vat !== 0 ? '$ ' + parseFloat(upcomingSwitchTotal / 5).toFixed(2) : '-'}</span>*/}
                                <span>{ isTaxed && taxAmount ? parseFloat(taxAmount).toFixed(2) :
                                    vat && vat !== 0 ? '$' + parseFloat(vat).toFixed(2) : '-'}</span>
                            </div>
                        </React.Fragment>
                        :
                        ''
                    }


                    {/*{console.log('cartsListData: ', this.props.cartList, this.props.vat)}*/}
                    {(this.props.cartListTitle === 'Phone Numbers') && this.props.cartList && this.props.cartList.length && this.props.vat ?
                        <div className='text-wrapper'>
                            <span>VAT:</span>
                             <span>{'$' + vat.toFixed(2)}</span>
                        </div>
                        :
                        ''
                    }
                    {/*{(this.state.discountedAmount !== '') && (!upcomingSwitchPlans ||(!upcomingSwitchPlans.lines || !upcomingSwitchPlans.lines.data || !upcomingSwitchPlans.discount || !upcomingSwitchPlans.discount.coupon )) ?*/}

                        {/*<div className='text-wrapper'>*/}
                            {/*<span>VAT:</span>*/}
                            {/*<span><strong>{vat && vat !== 0 ? '$ ' + parseFloat(this.props.discountedAmount * 0.2).toFixed(2) : '-'}</strong></span>*/}
                        {/*</div>*/}
                        {/*:*/}
                        {/*!upcomingSwitchTotal ?*/}
                            {/*<div className='text-wrapper'>*/}
                                {/*<span>VAT:</span>*/}
                                {/*<span><strong>{vat && vat !== 0 ? '$ ' + parseFloat(vat).toFixed(2) : '-'}</strong></span>*/}
                            {/*</div>*/}
                            {/*:*/}
                            {/*''*/}
                    {/*}*/}
                    {/*{(this.state.discountedAmount !== '') && (!upcomingSwitchPlans ||(!upcomingSwitchPlans.lines || !upcomingSwitchPlans.lines.data || !upcomingSwitchPlans.discount || !upcomingSwitchPlans.discount.coupon )) ?*/}
                    {/*{(this.state.discountedAmount !== '') && (!upcomingSwitchPlans ||(!upcomingSwitchPlans.lines || !upcomingSwitchPlans.lines.data )) ?*/}

                    <div className='text-wrapper margin-top-20 border-top'>
                        <span><strong>Total:</strong></span>
                        <h2>${ upcomingSwitchPlans && invoiceEstimate && invoiceEstimate.amountDue ?
                            (invoiceEstimate.amountDue / 100).toFixed(2)
                            :
                            upcomingSwitchPlans && invoiceEstimate && (invoiceEstimate.amountDue === 0) ?
                                invoiceEstimate.amountDue.toFixed(2)
                                :
                                upcomingSwitchPlans && nextInvoiceEstimate && nextInvoiceEstimate.amountDue ?
                                    (nextInvoiceEstimate.amountDue / 100).toFixed(2)
                                    :
                                    upcomingSwitchPlans && nextInvoiceEstimate && (nextInvoiceEstimate.amountDue === 0) ?
                                        nextInvoiceEstimate.amountDue.toFixed(2)
                                        :
                                        totalAmount ? parseFloat(totalAmount).toFixed(2) : '0.00'
                        }</h2>
                    </div>

                    {(this.props.withCheckout && !this.props.noButton) || this.props.viberSubscriptionSelected ?
                        <div className='margin-top-20'>
                            {/*<button className='btn-action btn-large' disabled={this.props.checkoutDisabled}*/}
                            {/*        onClick={()=>this.setState({stripeReplacementModal: true})}>Proceed to*/}
                            {/*    Checkout {this.props.spinner ?*/}
                            {/*        <i className='fa fa-spin fa-spinner'></i> : ''}</button>*/}
                            <button
                                className='btn-action btn-large '
                                id='add-payment-method'
                                disabled={this.props.checkoutDisabled}
                                onClick={this.props.handleSubmit}
                            >
                                Proceed to Checkout {this.props.spinner ? <i className='fa fa-spin fa-spinner'></i> : ''}</button>
                            <p className='grey-text text-align-center margin-top-10'>You won't be charged yet</p>
                            {/*<StripeReplacementModal*/}
                            {/*    showModal={this.state.stripeReplacementModal}*/}
                            {/*    handleClose={() => this.setState({stripeReplacementModal: false})}*/}
                            {/*    maxWidth={600}*/}
                            {/*    history={this.props.history}*/}
                            {/*    user={this.props.user}*/}
                            {/*    updateUserFromServer={this.props.updateUserFromServer}*/}
                            {/*/>*/}
                        </div>
                        :
                        ''
                    }
                    {
                        this.props.topUpActive ?
                            <Callout
                                icon='info-sign' intent={Intent.PRIMARY}
                            >
                                New balance after payment { futureCredit }
                            </Callout>
                            :
                            ''
                    }

                </div>
                <div className='order-summary-terms'>
                    <a href="https://emitto.io/terms-of-service" target="_blank">Terms & Conditions</a>
                </div>
            </div>
        )
    }
}

export default OrderSummary;